<app-breadcrumb [title]="'Checkout'" class="hidevalue" [breadcrumb]="'Checkout'"></app-breadcrumb>

<!-- <h1>{{lenData.length}}</h1> -->
<div *ngIf="lenData.length == 0" id="checkoutloader">
    <div style="height: 743px;">
        <!-- <h6>dfsdfdgfdi</h6> -->
        <!-- <h1 style="color: white;">dfgdsafgsdjhgbvcfsdjgfsdljgf</h1> -->
        <div class="preloader">
            <div class="loader">
                <div class="loaderzig">
                    <div class="loader__part loader__part--1"></div>
                    <div class="loader__part loader__part--2"></div>
                    <div class="loader__part loader__part--3"></div>
                </div>
            </div>
        </div>
    </div>
</div>


<section class="section-b-space" style="position: static;" *ngIf="lenData.length > 0" id="ordcust">
    <div class="container">
        <div class="checkout-page" id="checkoutpage">
            <div class="checkout-form">
                <!-- <form> -->
                <div class="row">
                    <div class="col-lg-6 col-sm-12 col-xs-12">

                        <div class="checkout-details" *ngIf="hidevalue == 1" style="margin-bottom: 20px;">

                            <!-- <div class="checkout-details" style="margin-bottom: 20px;"
                                *ngIf="(!cusAddress || cusAddress.length === 0 || !showFirstCard) && showSecondCard">
                                                                > -->
                            <div class="order-box" id="customerdata">
                                <div class="row align-items-center">
                                    <div class="col-lg-12 col-md-12 col-12 pb-4">
                                        <h3 class="checkout-titletext">Billing Details
                                            <button *ngIf="checkvalue == 2" type="submit"
                                                class="btn btn-solid p-1 choose-customer-btn float-end"
                                                (click)="NewCustomer(1)">
                                                Choose Customer
                                            </button>
                                        </h3>
                                    </div>

                                </div>

                                <form [formGroup]="checkoutForm" (ngSubmit)="SaveAddress()">
                                    <div class="row check-out">
                                        <!-- Name Field -->
                                        <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                            <div class="field-label">Name <span class="text-danger">*</span></div>
                                            <input type="text" formControlName="name" placeholder="Enter Name"
                                                autocomplete="off" maxlength="25"
                                                (keypress)="validateAlphabeticInput($event)" />
                                            <div *ngIf="checkoutForm.controls.name.touched && checkoutForm.controls.name.errors?.required"
                                                class="text text-danger">
                                                Name is required.
                                            </div>
                                        </div>

                                        <!-- Alternate Phone Field -->
                                        <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                            <div class="field-label">Alternate Phone <span class="text-danger">*</span>
                                            </div>
                                            <input type="text" formControlName="phone" placeholder="Enter Phone Number"
                                                autocomplete="off" maxlength="10"
                                                (keypress)="validateNumericInput($event)" />
                                            <div *ngIf="checkoutForm.controls.phone.touched && checkoutForm.controls.phone.errors?.required"
                                                class="text text-danger">
                                                Phone No is required.
                                            </div>
                                            <div *ngIf="checkoutForm.controls.phone.touched && checkoutForm.controls.phone.errors?.pattern"
                                                class="text text-danger">
                                                Phone No must be a valid number.
                                            </div>
                                        </div>
                                        <!--state Field-->
                                        <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                            <div class="field-label">State <span class="text-danger">*</span></div>
                                            <select formControlName="state" class="form-control"
                                                (change)="onStateChange($event)">
                                                <option value="" disabled selected>Select a state</option>
                                                <option value="Tamil Nadu">Tamil Nadu</option>
                                                <option value="Andhra Pradesh">Andhra Pradesh</option>
                                                <option value="Telangana">Telangana</option>
                                                <option value="Karnataka">Karnataka</option>
                                                <option value="Pondicherry">Pondicherry</option>
                                            </select>
                                            <div *ngIf="checkoutForm.controls.state.touched && checkoutForm.controls.state.errors?.required"
                                                class="text text-danger">State is required.</div>
                                                      
                                        </div>

                                        <!-- City Field -->
                                        <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                            <div class="field-label">City <span class="text-danger">*</span></div>
                                            <select formControlName="city" class="form-control"
                                                [disabled]="cities.length === 0" (ngModelChange)="changecity()">
                                                <option value="" disabled selected>Select a city</option>
                                                <option *ngFor="let city of cities" [value]="city">{{ city }}</option>
                                            </select>
                                            <div *ngIf="checkoutForm.controls.city.touched && checkoutForm.controls.city.errors?.required"
                                                class="text text-danger">City is required.</div>
                                                      
                                        </div>


                                        <!-- Postal Code Field -->
                                        <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                            <div class="field-label">Postal Code <span class="text-danger">*</span>
                                            </div>
                                            <input type="text" formControlName="postalcode"
                                                placeholder="Enter Postal Code" autocomplete="off" maxlength="6"
                                                (keypress)="validateNumericInput($event)" />
                                            <div *ngIf="checkoutForm.controls.postalcode.touched && checkoutForm.controls.postalcode.errors?.required"
                                                class="text text-danger">
                                                Postal Code is required.
                                            </div>

                                            <div *ngIf="checkoutForm.controls.postalcode.touched && checkoutForm.controls.postalcode.errors?.pattern"
                                                class="text text-danger">
                                                invalid Postal Code
                                            </div>
                                        </div>

                                        <!-- City Field -->
                                        <!-- <div class="form-group col-md-6 col-sm-12 col-xs-12">
                                            <div class="field-label">City <span class="text-danger">*</span></div>
                                            <input type="text" formControlName="town" placeholder="Enter City"
                                                autocomplete="off" maxlength="25"
                                                (keypress)="validateAlphabeticInput($event)" />
                                            <div *ngIf="checkoutForm.controls.town.touched && checkoutForm.controls.town.errors?.required"
                                                class="text text-danger">
                                                City is required.
                                            </div>
                                        </div> -->

                                        <!-- Address Field -->
                                        <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                            <div class="field-label">
                                                Address <span class="text-danger">*</span>

                                            </div>
                                            <textarea formControlName="address" rows="2" placeholder="Enter Address"
                                                style="padding: 10px 22px;" autocomplete="off"
                                                maxlength="150"></textarea>
                                            <div *ngIf="checkoutForm.controls.address.touched && checkoutForm.controls.address.errors?.required"
                                                class="text text-danger">
                                                Address is required.
                                            </div>
                                            <div *ngIf="checkoutForm.controls.address.touched && checkoutForm.controls.address.errors?.minlength"
                                                class="text text-danger">
                                                Address must be at least 10 characters long.
                                            </div>
                                        </div>

                                        <!-- Landmark Field -->
                                        <div class="form-group col-md-12 col-sm-6 col-xs-12">
                                            <div class="field-label">Landmark (Optional)</div>
                                            <input type="text" formControlName="state" placeholder="Enter Landmark"
                                                autocomplete="off" maxlength="50" />
                                        </div>

                                        <!-- Delivery Checkbox -->
                                        <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                            <div class="field-label btn-toolbar">

                                                <div>
                                                    <span> Delivery Here :</span>
                                                </div>
                                                <div>
                                                    <input type="checkbox" formControlName="iscurrentaddress"
                                                        (change)="changefilter($event.target.checked)"
                                                        style="height: 18px;margin-top: 4px;    margin-left: 10px;" />
                                                </div>


                                            </div>
                                        </div>

                                        <!-- Save Button -->
                                        <div class="text-end col-md-6 col-sm-6 col-xs-12">
                                            <button type="submit" id="save-btn" aria-label="Save Data"
                                                class="btn-solid btn">
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </form>


                            </div>
                        </div>



                        <!-- SHOW CUSTOMER DETAILS -->
                        <!-- <h1>{{hidevalue}}</h1>
                        <span *ngIf="hidevalue == 2" >sdgfjhsdgjhfg</span> -->

                        <div class="checkout-details" *ngIf="hidevalue == 2" style="margin-bottom: 10px;"
                            id="checkoutdetailssysview">
                            <!-- <div class="checkout-details" style="margin-bottom: 10px;"
                            *ngIf="cusAddress && cusAddress.length > 0 && showFirstCard"
                            > -->

                            <div class="address-cards hidevalue">
                                <div class="row" style="padding-bottom: 10px;">
                                    <div class="col-md-6">
                                        <h4 class="checkout-titlefont" *ngIf="checkvalue ==1">
                                            Delivery Address
                                        </h4>
                                        <h4 class="checkout-titlefont" *ngIf="checkvalue == 2">
                                            Select Delivery Address
                                        </h4>

                                    </div>
                                    <div class="col-md-6">
                                        <button *ngIf="checkvalue == 1" type="submit" id="newcustomer-btn"
                                            aria-label="newcustomer Data" class="btn btn-solid p-2"
                                            style="float: inline-end;" (click)="NewCustomer(2)">
                                            + Add New Address
                                        </button>

                                        <button *ngIf="checkvalue == 2" type="submit" id="choosecust-btn"
                                            aria-label="choosecust Data" class="btn btn-solid p-2"
                                            style="float: inline-end;" (click)="NewCustomer(1)">
                                            Choose Address
                                        </button>
                                    </div>

                                </div>

                                <div class="card" [ngClass]="{'current-address': address.iscurrentaddress}"
                                    style="margin-bottom: 10px; background-color: white;border-radius: initial;"
                                    *ngFor="let address of filteredAddresses">
                                    <div class="card-body">
                                        <h5 class="card-title">{{ address.name.toUpperCase() }} <span
                                                *ngIf="address.iscurrentaddress"
                                                style="color: green; font-size: smaller;"> (Default)</span></h5>

                                        <p class="card-text" style="font-family: sans-serif;">{{
                                            address.address.toUpperCase() }}.


                                        </p>

                                        <button type="button" class="btn btn-outline-success m-2" id="select-btn"
                                            aria-label="select Data" *ngIf="!address.iscurrentaddress"
                                            (click)="selectCustomerAddress(address.customerId, address.id)">Select
                                            Delivery Address</button>

                                        <button type="button" class="btn btn-outline-danger m-2" id="remove"
                                            aria-label="remove Data" *ngIf="!address.iscurrentaddress" Tooltip="Remove"
                                            (click)="remove(address)">
                                            <i class="ti-trash" aria-hidden="true"></i>
                                        </button>

                                    </div>
                                </div>
                            </div>

                            <div class="address-cards mobilehide">
                                <div class="row" style="padding-bottom: 10px;">
                                    <div class="col-6">
                                        <h4 class="checkout-titlefont" *ngIf="checkvalue ==1">
                                            Delivery Address
                                        </h4>
                                        <h4 class="checkout-titlefont" *ngIf="checkvalue == 2">
                                            Select Delivery Address
                                        </h4>
                                    </div>
                                    <div class="col-6">
                                        <button *ngIf="checkvalue == 1" type="submit" class="btn btn-solid p-2"
                                            id="newaddrs-btn" aria-label="newaddrs Data"
                                            style="float: inline-end;    line-height: 15px;    font-size: 12px;"
                                            (click)="NewCustomer(2)">
                                            + Add New Address
                                        </button>

                                        <button *ngIf="checkvalue == 2" type="submit" class="btn btn-solid p-2"
                                            id="chooseaddrs-btn" aria-label="chooseaddrs Data"
                                            style="float: inline-end;    line-height: 15px;    font-size: 12px;"
                                            (click)="NewCustomer(1)">
                                            Choose Address
                                        </button>
                                    </div>

                                </div>

                                <div class="card" [ngClass]="{'current-address': address.iscurrentaddress}"
                                    style="margin-bottom: 10px; background-color: white;border-radius: initial;"
                                    *ngFor="let address of filteredAddresses">
                                    <div class="card-body">
                                        <h5 class="card-title" style="font-size: 12px;">{{ address.name.toUpperCase() }}
                                            <span *ngIf="address.iscurrentaddress"
                                                style="color: green; font-size: smaller;"> (Default)</span>
                                        </h5>

                                        <p class="card-text"
                                            style="font-family: sans-serif;font-size: 12px;    line-height: 18px;">{{
                                            address.address.toUpperCase() }}.


                                        </p>

                                        <button type="button" class="btn btn-outline-success m-2"
                                            *ngIf="!address.iscurrentaddress" id="selectdeladdrs-btn"
                                            aria-label="selectdeladdrs Data"
                                            (click)="selectCustomerAddress(address.customerId, address.id)">Select
                                            Delivery Address</button>

                                        <button type="button" class="btn btn-outline-danger m-2" id="remove-btn"
                                            aria-label="remove Data" *ngIf="!address.iscurrentaddress" Tooltip="Remove"
                                            (click)="remove(address)">
                                            <i class="ti-trash" aria-hidden="true"></i>
                                        </button>

                                    </div>
                                </div>
                            </div>

                        </div>


                        <!-- DATE PICKER -->

                        <div class="checkout-details" *ngIf="hidevalue == 2">




                            <!-- <div class="row">
                                <p class="checkout-title" style="font-weight: 700;font-size: 15px;color: #444444;">
                                    Delivery Date & Time
                                    <span class="text-danger">*</span>
                                </p>

                                <div class="col-lg-6">

                                    <div class="input-group" style="padding-top: 32px;">
                                        <input class="form-control" placeholder="yyyy-mm-dd" name="dp"
                                            [(ngModel)]="deliveryDate" ngbDatepicker #d="ngbDatepicker"
                                            [minDate]="minDate" (ngModelChange)="onDeliveryDateChange($event)" />

                                        <button class="btn border bi bi-calendar3" (click)="d.toggle()" type="button"><i
                                                class="fa fa-calendar" aria-hidden="true"></i></button>

                                    </div>
                                </div>


                                <div class="col-lg-6">
                                    <form [formGroup]="timeForm">
                                        <ngb-timepicker formControlName="selectedTime"
                                            [meridian]="true"></ngb-timepicker>
                                    </form>
                                </div>
                            </div> -->

                            <div class="row" id="selectdatetime">
                                <p class="checkout-title" style="font-weight: 700;font-size: 15px;color: #444444;">
                                    Delivery Date & Time
                                    <span class="text-danger">*</span>
                                </p>

                                <div class="col-lg-6">

                                    <div class="input-group" style="padding-top: 32px;">
                                        <input class="form-control rder" placeholder="yyyy-mm-dd" name="dp"
                                            [(ngModel)]="deliveryDate" ngbDatepicker #d="ngbDatepicker"
                                            [minDate]="minDate" (ngModelChange)="onDeliveryDateChange($event)" />

                                        <button class="btn border bi bi-calendar3" (click)="d.toggle()" type="button"><i
                                                class="fa fa-calendar" aria-hidden="true"></i></button>

                                    </div>
                                </div>


                                <div class="col-lg-6">
                                    <form [formGroup]="timeForm">
                                        <ngb-timepicker formControlName="selectedTime" (ngModelChange)="checktime()"
                                            [readonlyInputs]="true" [meridian]="true"></ngb-timepicker>
                                    </form>
                                </div>

                                <!-- <div>                                 
                                    <span class="al" style="color: green;"
                                        *ngIf="(this.timeForm.value.selectedTime.hour>=10 && this.timeForm.value.selectedTime.minute>=00 && this.timeForm.value.selectedTime.hour<=20 && this.timeForm.value.selectedTime.minute<=60)">It's
                                        Valid Date & Time</span>
                                    <br>
                                    <span class="al"
                                        *ngIf="(this.timeForm.value.selectedTime.hour<=9  || this.timeForm.value.selectedTime.hour>=21)">*
                                        If you choose today. please choose delivery time after 2 hours from right
                                        time.<br>* We can deliver cake order between 10.00 A.M to 09:00 P.M</span>
                                </div> -->

                                <div>
                                    <!-- {{invalidTime}}{{this.timeForm.value.selectedTime.hour}}{{this.timeForm.value.selectedTime.hour}}
                                    {{dbool}} -->

                                    <div *ngIf="dbool==true">
                                        <!-- <br> -->
                                        <!-- Show valid time message -->
                                        <span class="al" style="color: green;"
                                            *ngIf="this.timeForm.value.selectedTime.hour >= 10 && this.timeForm.value.selectedTime.hour <= 22 && invalidTime == false">
                                            ✅ Your delivery time is valid! (Between 10:00 AM - 09:00 PM). Your order is
                                            expected to arrive by [current time + 2 hours].
                                        </span>


                                        <span *ngIf="invalidTime" class="al" style="color: red;">
                                            ⚠️ Invalid Time! Please select a delivery time between 10:00 AM and 10:00
                                            PM.

                                        </span>


                                    </div>

                                    <div *ngIf="dbool==false">
                                        <span class="al" style="color: green;"
                                            *ngIf="(this.timeForm.value.selectedTime.hour >= 10 && this.timeForm.value.selectedTime.hour < 22) && invalidTime == false">
                                            ✅ Your delivery time is valid! (Between 10:00 AM - 10:00 PM). Your order is
                                            expected to arrive by [current time + 2 hours].
                                        </span>

                                        <span *ngIf="invalidTime" class="al" style="color: red;">
                                            ⚠️ Invalid Time! Please select a delivery time between 10:00 AM and 10:00
                                            PM, ensuring it is at least 2 hours from now.
                                        </span>
                                    </div>
                                </div>

                            </div>

                        </div>



                    </div>


                    <!-- PRODUCT DETAILS -->

                    <div class="col-lg-6 col-sm-12 col-xs-12" id="producttabledetail">
                        <div class="checkout-details" style="padding: 10px;" *ngIf="cartvalue == 1">
                            <div class="order-box">
                                <div class="checkout-title">
                                    <h3>Product Details</h3>
                                </div>
                                <!-- <div class="table-responsive-md"> -->
                                <table class="table cart-table table-responsive-xs" *ngIf="lenData.length">
                                    <thead>
                                        <tr>
                                            <th>Image</th>
                                            <th>Product Name</th>
                                            <th>Price</th>
                                            <th style="text-align: center;">Qty</th>
                                            <!-- <th>Total</th> -->
                                        </tr>
                                    </thead>
                                    <tbody *ngFor="let product of Livecart">
                                        <tr>
                                            <td style="width: 15%;">
                                                <img [src]="product.products.ImgUrl" [alt]="product.products.Name"
                                                    style="height: 85px;">
                                            </td>
                                            <td style="width: 30%;">{{ product.products?.Name }} <span
                                                    *ngIf="product.weight.QtyText.length > 0"> -
                                                    {{product.weight.QtyText }}</span>
                                                <div *ngFor="let addns of product.addons">
                                                    <h6> {{addns.qtyText }} </h6>
                                                </div>
                                                <h6> {{product.variants?.qtyText }} </h6>


                                                <h6 class="text-light-emphasis">
                                                    <!-- <strong>Msg</strong>: -->

                                                    <span style="font-style: italic;" *ngIf="product.Msg?.length > 0">
                                                        "{{product.Msg
                                                        }}"</span>

                                                </h6>

                                                <div class="mobile-cart-content row">
                                                    <div class="col-sm-12">
                                                        <div class="qty-box"
                                                            *ngIf="HideCoupon == false && HideReferral == false">
                                                            <div class="input-group"
                                                                style="justify-content: flex-start;">
                                                                <span class="input-group-prepend">
                                                                    <button type="button"
                                                                        class="btn quantity-left-minus"
                                                                        data-type="minus" id="minus-btn"
                                                                        aria-label="minus Data"
                                                                        (click)="decrement(product)">
                                                                        -
                                                                    </button>
                                                                </span>
                                                                <input type="text" name="quantity" style="height: 26px;padding-left: 0;
                                                                padding-right: 0;
                                                                width: 40px;" class="form-control input-number"
                                                                    disabled [(ngModel)]="product.Quantity_No">
                                                                <span class="input-group-prepend">
                                                                    <button type="button"
                                                                        class="btn quantity-right-plus" data-type="plus"
                                                                        id="plus-btn" aria-label="plus Data"
                                                                        (click)="increment(product)">
                                                                        +
                                                                    </button>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-12 mt-2">
                                                        <strong> &#8377;{{ product.ProdTotal *
                                                            product.Quantity_No | number:'1.2-2'}}</strong>
                                                    </div>
                                                </div>

                                            </td>

                                            <td style="width: 15%;"> &#8377; <span></span> {{product.ProdTotal | number:
                                                '1.2-2' }}
                                            </td>

                                            <td class="text-center" style="width:45%;">
                                                <div class="qty-box"
                                                    *ngIf="HideCoupon == false && HideReferral == false">
                                                    <div class="input-group">
                                                        <span class="input-group-prepend">
                                                            <button type="button" class="btn quantity-left-minus"
                                                                data-type="minus" id="minus-btn" aria-label="minus Data"
                                                                (click)="decrement(product)">
                                                                -
                                                            </button>
                                                        </span>
                                                        <input type="text" name="quantity" style="height: 26px;padding-left: 0;
                                                        padding-right: 0;
                                                        width: 40px;" class="form-control input-number" disabled
                                                            [(ngModel)]="product.Quantity_No">
                                                        <span class="input-group-prepend">
                                                            <button type="button" class="btn quantity-right-plus"
                                                                data-type="plus" id="plus-btn" aria-label="plus Data"
                                                                (click)="increment(product)">
                                                                +
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div><br>

                                                <!-- </td>


                                            <td style="width:20%;"> -->
                                                <span style="margin-top: 6px;font-size: 14px;"> <strong>Total:</strong>
                                                    &#8377;
                                                    <span [class.cmd]="product.coupontotal">{{ product.ProdTotal *
                                                        product.Quantity_No | number:'1.2-2'}}
                                                    </span>
                                                    <span *ngIf="product.coupTypeid == 2">
                                                        ({{product.coupvalue}}%)</span>
                                                    <span *ngIf="product.coupTypeid == 1"> (&#8377;{{product.coupvalue}}
                                                        )</span>
                                                </span><br>
                                                <span style="color: green;" *ngIf="product.coupontotal">&#8377; <span>{{
                                                        product.coupontotal | number:'1.2-2'}}</span></span>
                                            </td>

                                        </tr>
                                    </tbody>
                                </table>
                                <!-- </div> -->
                                <div *ngIf="!lenData.length" class="empty-checkout">
                                    There are no products in cart
                                </div>
                                <div>
                                    <div><strong>Order Message (optional)</strong></div>
                                    <div style="margin-top: 10px;">
                                        <textarea class="formControl auto-expand"
                                            style="padding: 10px; min-height: 50px; max-height: 150px; overflow: hidden; resize: none;"
                                            maxlength="150" [(ngModel)]="note" (input)="autoResize($event)"
                                            placeholder="eg: kindly provide extra spoons and plates...">
                                        </textarea>
                                    </div>

                                </div>
                                <!-- 01-03-2025 -->

                                <hr *ngIf="Coupons.length > 0">
                                <div class="select" *ngIf="Coupons.length > 0 && ordCount >= 0">
                                    <span> *Please choose either a Coupon Code or a Referral Code. Only one can be
                                        applied at a time.</span>
                                              
                                </div>

                                <div class="coupon" *ngIf="Coupons.length > 0 && HideReferral == false">
                                    <div style="margin-top: 10px;"><strong>Apply Coupon</strong></div>
                                    <div class="col-lg-12" style="margin-top: 10px;">
                                        <div class="flex-container" *ngIf="HideCoupon == false">
                                            <div class="col-md-8">
                                                <input style="height: 30px;    padding: 0 10px;" class="form-control"
                                                    type="text" [(ngModel)]="Code" placeholder="Enter Coupon Code"
                                                    (ngModelChange)="typeCode()" autocomplete="off" maxlength="8"
                                                    aria-label="Coupon Code">

                                                <span style="color: red;" *ngIf="checkCoupon == true">Invalid Coupon
                                                    Code</span>
                                            </div>
                                            <!-- <div class="col-md-4">
                                                <button type="button" class="btn btn-outline-success btn-sm"
                                                    id="apply-btn" aria-label="apply Data"
                                                    (click)=" applyCoupon() ">Apply
                                                    Coupon</button>
                                            </div> -->

                                            <div class="col-md-4">
                                                <button type="button" class="btn btn-outline-success btn-sm"
                                                    id="apply-btn" aria-label="Apply Referral" (click)="applyCoupon()"
                                                    [disabled]="loadingcoup">
                                                    <span *ngIf="!loadingcoup">Apply Referral</span>
                                                    <span *ngIf="loadingcoup">
                                                        <i class="fa fa-spinner fa-spin"></i> Applying...
                                                    </span>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="col-md-12 flex-container showcode" *ngIf="HideCoupon == true">
                                            <div class="col col-md-8 gencode">
                                                <span style="    font-family: none;
                                                font-weight: 600;
                                                font-size: 18px;">You Save:&#8377; {{CouponAmount}} </span><br>
                                                <span style="font-family: none;
                                                
                                                font-size: 12px;">Coupon Applied: <strong
                                                        style="color: green;    font-size: 15px;">{{Code}}</strong>
                                                </span>
                                            </div>
                                            <div class="col col-md-4 delcoup">
                                                <a style="color: red;"><i class="fa fa-trash" aria-hidden="true"
                                                        (click)="deleteCoupon()"></i></a>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="mt-3">
                                        <strong>Applicable Coupons</strong>
                                        <ul style="padding-top: 10px;margin: 0;margin-left: 12px; "
                                            *ngFor="let data of Coupons">
                                            <li class="mb-2">
                                                <div
                                                    class="m-checkbox-inline mb-0 custom-radio-ml d-flex radio-animated">
                                                    <label class="d-block"
                                                        [class.disabled]="data.id != selectedCouponId && selectedCouponId > 0">
                                                        <input class="radio_animated" type="radio" [value]="data.id"
                                                            name="coupon" [(ngModel)]="selectedCouponId"
                                                            (ngModelChange)="selectCode(data)">
                                                        <span style="color: black;">
                                                            {{data.couponCode}} - <span
                                                                *ngIf="data.cop_prod.typeId == 1">₹</span> <span
                                                                style="    margin-left: 2px;">{{data.cop_prod.value}}
                                                                <span *ngIf="data.cop_prod.typeId == 2">%</span>

                                                                Offer</span> <span class="m-2"
                                                                style="font-size: smaller;color: brown;"
                                                                *ngIf="data.cop_prod.offProdId != null">({{data.cop_prod.description}})</span>
                                                        </span>
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div> <br>

                                <div class="coupon" *ngIf="ordCount >= 0 && HideCoupon == false">
                                    <div style="margin-top: 10px;"><strong>Apply Referral</strong></div>
                                    <div class="col-lg-12" style="margin-top: 10px;">
                                        <div class="flex-container" style="margin-bottom: 15px;"
                                            *ngIf="HideReferral == false">
                                            <div class="col-md-8">
                                                <input style="height: 30px;    padding: 0 10px;" class="form-control"
                                                    type="text" [(ngModel)]="RefCode" placeholder="Enter Referral Code"
                                                    (ngModelChange)="typeCode()" autocomplete="off" maxlength="8"
                                                    aria-label="Coupon Code">

                                                <span style="color: red;"
                                                    *ngIf="checkreferral == true">{{Invalidrefcode}}</span>
                                            </div>
                                            <!-- <div class="col-md-4">
                                                <button type="button" class="btn btn-outline-success btn-sm"
                                                    id="apply-btn" aria-label="Apply Referral"
                                                    (click)="applyReferral()">Apply Referral</button>
                                            </div> -->

                                            <div class="col-md-4">
                                                <button type="button" class="btn btn-outline-success btn-sm"
                                                    id="apply-btn" aria-label="Apply Referral" (click)="applyReferral()"
                                                    [disabled]="loading">
                                                    <span *ngIf="!loading">Apply Referral</span>
                                                    <span *ngIf="loading">
                                                        <i class="fa fa-spinner fa-spin"></i> Applying...
                                                    </span>
                                                </button>
                                            </div>

                                        </div>

                                        <div *ngIf="HideReferral == true">
                                            <span><strong>Note : </strong> please complete your order using online
                                                payment only.</span> <br>

                                            <div class="col-md-12 flex-container showcode" style="margin-top: 10px;"
                                                *ngIf="HideReferral == true">

                                                <div class="col col-md-8 gencode" style="padding-top: 5px;">

                                                    <span style="font-family: none;
                                                
                                                font-size: 12px;">Referral Applied: <strong
                                                            style="color: green;    font-size: 15px;">{{RefCode}}</strong>
                                                    </span><br>
                                                    <span class="shine-text" style="    font-family: none;
                                                font-weight: 600;
                                                font-size: 18px;">You Save : &#8377; {{ReferralAmount}} </span>

                                                </div>
                                                <div class="col col-md-4 delcoup">
                                                    <a href="javascript:void(0)" style="color: red;font-size: larger;"
                                                        data-bs-toggle="tooltip" data-bs-placement="top"
                                                        title="Delete Referral">
                                                        <i class="fa fa-trash" aria-hidden="true"
                                                            (click)="deleteReferral()"></i>
                                                    </a>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>


                                <hr>
                                <div class="flex-container">

                                    <div class="flex-child">
                                        Sub Total
                                    </div>

                                    <div class="flex-child">
                                        ₹ {{TotalAMount - taxAmt | number:'1.2-2'}}
                                    </div>

                                </div>
                                <div class="flex-container">

                                    <div class="flex-child">
                                        Tax {{ tax }}%
                                    </div>

                                    <div class="flex-child">
                                        ₹ {{taxAmt | number:'1.2-2'}}
                                    </div>

                                </div>

                                <div class="flex-container" *ngIf="HideCoupon == true">

                                    <div class="flex-child">
                                        Discount
                                    </div>

                                    <div class="flex-child">
                                        <span style="color: black;">
                                            <span *ngIf="selectedCoupon?.cop_prod.typeId == 1">₹</span> <span
                                                style="margin-left: 2px;">{{selectedCoupon?.cop_prod.value}}
                                                <span *ngIf="selectedCoupon?.cop_prod.typeId == 2">%</span>
                                            </span>
                                        </span>
                                    </div>

                                </div>

                                <div class="flex-container" *ngIf="HideReferral == true">

                                    <div class="flex-child">
                                        Discount
                                    </div>

                                    <div class="flex-child">
                                        <span style="color: black;">
                                            ₹ {{ReferralAmount | number:'1.2-2'}}
                                        </span>
                                    </div>

                                </div>


                                <hr>

                                <div class="flex-container">

                                    <div class="flex-child">
                                        <strong style="font-size: 17px; color: rgb(255, 81, 0);">Total</strong>
                                    </div>

                                    <div class="flex-child">
                                        <strong style="font-size: 17px; color: rgb(255, 81, 0);"> &#8377; {{ BillAmount
                                            |
                                            number:".2"}}</strong>
                                    </div>

                                </div>



                                <!-- <div class="row check-out">

                                    <div class="form-group col-xs-12">

                                        <div class="field-label"> Order Notes (Optional)
                                        </div>

                                        <textarea type="text" class="formControl col-xl-8 col-md-7 w-100"
                                            [(ngModel)]="note"
                                            placeholder="Eg:Kindly Provide Extra Plates and Spoon"></textarea>
                                    </div>
                                </div>


                                <ul class="sub-total">

                                    <li>
                                        Subtotal <span class="count">&#8377;
                                            {{ getTotal | async | number:'1.2-2'
                                            }}</span>
                                    </li>

                                    <li>
                                        Tax - <span>({{ tax }})</span> <span *ngIf="tax" class="count">
                                            &#8377; {{ amount * taxAmt /100 | number:'1.2-2'}}
                                        </span>
                                    </li>
                                </ul>

                                <ul class="total">
                                    <li>Total Price : <span class="count">&#8377; {{ BillAmount |
                                            number:".2"}}</span></li>
                                </ul> -->
                            </div>

                            <div class="payment-box">
                                <div class="upper-box">

                                    <div class="payment-options row">
                                        <ul>
                                            <li>

                                                <div class="form-group col">
                                                    <p class="checkout-title" style="color: black;">
                                                        <strong>Payment Options</strong>
                                                        <span class="text-danger">*</span>
                                                    </p>
                                                    <div
                                                        class="m-checkbox-inline mb-0 custom-radio-ml d-flex radio-animated">
                                                        <label class="d-block" for="edo-ani">
                                                            <input class="radio_animated" id="edo-ani" type="radio"
                                                                [value]="1" name="rdo-ani" value="online Payment"
                                                                [(ngModel)]="payment"
                                                                (ngModelChange)="paymenttype($event)"
                                                                style="color: #444444;"><span
                                                                style="color: black;">Online Payment</span>
                                                        </label>
                                                        <label class="d-block" for="edo-ani1" style="margin-left: 10%;">
                                                            <input class="radio_animated" id="edo-ani1" type="radio"
                                                                name="rdo-ani" [value]="2" [(ngModel)]="payment"
                                                                [disabled]="refTypeId != 3 && HideReferral == true"
                                                                value="cod" (ngModelChange)="paymenttype2($event)"
                                                                style="color: #444444;">
                                                            <span style="color: black;"> Cash on Delivery</span>
                                                        </label>
                                                    </div>
                                                </div>
                                        </ul>

                                    </div>
                                </div>


                                <!-- <div class="text-end">
                                    <button *ngIf="payment == 2" type="submit" class="btn-solid btn" id="placeord-btn"
                                        aria-label="placeord Data" (click)="placeOrderNow()">
                                        Place Order
                                    </button>
                                    <button *ngIf="payment == 1" type="submit" class="btn-solid btn" id="placeorder-btn"
                                        aria-label="placeorder Data" (click)="placeOrderNowbyOnline()">
                                        Place Order
                                    </button>
                                </div> -->

                                <div class="text-end">
                                    <button *ngIf="payment == 2" type="submit" class="btn-solid btn" id="placeord-btn"
                                        aria-label="placeord Data" (click)="Termsandcondition()">
                                        Place Order
                                    </button>
                                    <button *ngIf="payment == 1" type="submit" class="btn-solid btn" id="placeorder-btn"
                                        aria-label="placeorder Data" (click)="Termsandcondition()">
                                        Place Order
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <!-- </form> -->
            </div>
        </div>
    </div>
</section>



<!-- POPUP -->


<ng-template #Orddetail let-modal>
    <div class="modal-body">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="modal-body">

                    <div class="success-checkmark">
                        <div class="check-icon">
                            <span class="icon-line line-tip"></span>
                            <span class="icon-line line-long"></span>
                            <div class="icon-circle"></div>
                            <div class="icon-fix"></div>
                        </div>
                    </div>
                    <strong style="font-weight: 700;">


                        <h5 style="text-align: center;" *ngIf="OrdId">Your Order (#FBINO{{OrdId}}) Placed Successfully
                            !..</h5>
                    </strong>
                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-theme btn-sm" id="continue-btn" aria-label="continue Data"
                        data-dismiss="modal" (click)="continueshop()" [routerLink]="['home/fashion']">Continue
                        Shopping</button>
                    <button type="button" class="btn btn-theme btn-sm" id="track-btn" aria-label="track Data"
                        (click)="Trackord()">Track Order</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #AllertPayment let-modal>
    <div class="modal-body">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="modal-body">

                    <div class="message-box _success _failed">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                        <h2 style="font-size: 20px;"> Your payment failed </h2>
                        <p style="font-size: 15px;"> Your Order Not Saved, Online Payment Failed, Please Make COD </p>

                    </div>

                    <!-- <strong style="font-weight: 700;">
                        <h5 style="text-align: center;">Your Order Saved, Onlinepayment Failed, please Make COD</h5>
                    </strong> -->
                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-theme btn-sm" id="closepayment-btn"
                        aria-label="closepayment Data" (click)="closePaymenterror()">Close</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #SuccessPay let-modal>
    <div class="modal-body">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="modal-body">

                    <div class="success-checkmark">
                        <div class="check-icon">
                            <span class="icon-line line-tip"></span>
                            <span class="icon-line line-long"></span>
                            <div class="icon-circle"></div>
                            <div class="icon-fix"></div>
                        </div>
                    </div>

                    <strong style="font-weight: 700;">
                        <h2 style="font-size: 20px;text-align: center;"> Your payment Success </h2>
                        <h5 class="mt-3" style="text-align: center;font-size: large;">Your Order Placed Successfully
                            !..</h5>
                    </strong>

                    <!-- <div class="message-box _success _failed">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                        <h2 style="font-size: 20px;"> Your payment Success </h2>
                        <h5 style="text-align: center;" *ngIf="OrdId">Your Order Placed Successfully
                            !..</h5>

                    </div> -->

                    <!-- <strong style="font-weight: 700;">
                        <h5 style="text-align: center;">Your Order Saved, Onlinepayment Failed, please Make COD</h5>
                    </strong> -->
                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-theme btn-sm" id="continue-btn" aria-label="continue Data"
                        data-dismiss="modal" (click)="continueshop()" [routerLink]="['home/fashion']">Continue
                        Shopping</button>
                    <button type="button" class="btn btn-theme btn-sm" id="track-btn" aria-label="track Data"
                        (click)="Trackord()">Track Order</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<div style="display: none;" id="preloaderco">
    <!-- <img  alt=""> -->
    <div id="loaderco">
        <div class="loaderzigco">
            <div class="loaderco__part loaderco__part--1"></div>
            <div class="loaderco__part loaderco__part--2"></div>
            <div class="loaderco__part loaderco__part--3"></div>
        </div>
    </div>
</div>


<div class="mobileimg" style="background-color: white;height: 10%;">
    <h1 style="color: white;">ewrweqrweqrwqer</h1>
</div>





<ng-template #DeleteModel let-modal>
    <div class="modal-body">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="modal-body">

                    <div class="icon-box">
                        <span style="color: red;    font-size: 35px;"><i class="fa fa-trash-o" aria-hidden="true"
                                style="    margin-top: 20px;"></i></span>
                    </div>
                    <h4 class="modal-title w-100" style="    text-align: center;
                    margin-top: 20px;">Are you sure?</h4>

                    <p style="text-align: center;
                    margin-top: 10px;">Do you really want to delete these Address?</p>

                    <!-- <a href="simpleTest.html" id="confirm" onclick="return confirm('Are you sure?');">test confirm</a> -->
                    <!-- <div class="success-checkmark">
                        <div class="check-icon">
                            <span class="icon-line line-tip"></span>
                            <span class="icon-line line-long"></span>
                            <div class="icon-circle"></div> 
                            <div class="icon-fix"></div>
                        </div>
                    </div>
                    <strong style="font-weight: 700;">
                        <h5 style="text-align: center;" *ngIf="OrdId">Your Order (#FBINO{{OrdId}}) Placed Successfully
                            !..</h5>
                    </strong> -->
                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-theme btn-sm" data-dismiss="modal" id="cancel-btn"
                        aria-label="cancel Data" (click)="modal.dismiss('Cross click')">Cancel</button>
                    <button type="button" class="btn btn-theme btn-sm" (click)="DeleteAddress()" id="delete-btn"
                        aria-label="delete Data">Delete</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>



<!-- <ng-template #CustNotify let-modal>
    <div class="modal-body">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="modal-body">
                    <div class="icon-box">
                        <span style="color: red;    font-size: 35px;"><i class="fa fa-trash-o" aria-hidden="true"
                                style="    margin-top: 20px;"></i></span>
                    </div>
                    <h4 class="modal-title w-100" style="    text-align: center;
                    margin-top: 20px;">Are you sure?</h4>

                    <p style="text-align: center;
                    margin-top: 10px;">Do you really want to delete these Address?</p>             
                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-theme btn-sm" data-dismiss="modal" id="cancel-btn"
                        aria-label="cancel Data" (click)="modal.dismiss('Cross click')">Cancel</button>
                    <button type="button" class="btn btn-theme btn-sm" (click)="DeleteAddress()" id="delete-btn"
                        aria-label="delete Data">Delete</button>
                </div>
            </div>
        </div>
    </div>
</ng-template> -->



<!-- POPUP -->
<ng-template #errorModal let-modal>
    <div class="modal-body">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="modal-body"
                    style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; padding: 0;">

                    <!-- Centered icon box -->
                    <!-- Centered icon box -->
                    <div class="icon-box text-center"
                        style="position: relative; display: inline-block; width: 100px; height: 100px; background-color: #f0f0f0; border-radius: 50%; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;">
                        <i class="fa fa-frown-o" aria-hidden="true" style="font-size: 100px; color: red;"></i>
                    </div>


                    <!-- Message Text -->
                    <p style="text-align: center; margin-top: 10px; font-size: 16px; font-weight: 700;">
                        sorry! Order is not available for your location. Below are some nearby stores with their contact
                        details:
                    </p>

                    <!-- Table for Store Details -->
                    <div class="row">
                        <!-- Store 1 -->
                        <div class="col-lg-6">
                            <div class="card" style="margin-bottom: 20px;">
                                <div class="card-body">
                                    <h5 class="card-title">Keelavasal</h5>
                                    <p class="card-text">Address: 257 kamarajar salai, Madurai</p>
                                    <p class="card-text">Contact: 7339073370</p>
                                </div>
                            </div>
                        </div>

                        <!-- Store 2 -->
                        <div class="col-lg-6">
                            <div class="card" style="margin-bottom: 20px;">
                                <div class="card-body">
                                    <h5 class="card-title">AnnaNagar-Madurai</h5>
                                    <p class="card-text">Address: Meenatchi Towers, 188, 80FeetRd, AnnaNagar</p>
                                    <p class="card-text">Contact: 9566795888</p>
                                </div>
                            </div>
                        </div>

                        <!-- Store 3 -->
                        <div class="col-lg-6">
                            <div class="card" style="margin-bottom: 20px;">
                                <div class="card-body">
                                    <h5 class="card-title">ThabaalThanthiNagar</h5>
                                    <p class="card-text">Address: 65, Meenakshi Nagar Rd, Thabaal Thanthi Nagar</p>
                                    <p class="card-text">Contact: 8807210111</p>
                                </div>
                            </div>
                        </div>

                        <!-- Store 4 -->
                        <div class="col-lg-6">
                            <div class="card" style="margin-bottom: 20px;">
                                <div class="card-body">
                                    <h5 class="card-title">k.pudhur</h5>
                                    <p class="card-text">Address: Plot No.8, AB Tower, Karpaga Nagar, K.pudhur</p>
                                    <p class="card-text">Contact: 9500040111</p>
                                </div>
                            </div>
                        </div>

                        <!-- Store 5 -->
                        <div class="col-lg-6">
                            <div class="card" style="margin-bottom: 20px;">
                                <div class="card-body">
                                    <h5 class="card-title">BB.kulam</h5>
                                    <p class="card-text">Address: No 11 Vishaal Heights, V.P. Rathinasamy Nadar Rd, BB
                                        kulam</p>
                                    <p class="card-text">Contact: 9500086111</p>
                                </div>
                            </div>
                        </div>

                        <!-- Store 6 -->
                        <div class="col-lg-6">
                            <div class="card" style="margin-bottom: 20px;">
                                <div class="card-body">
                                    <h5 class="card-title">villapuram</h5>
                                    <p class="card-text">Address: 49, Aruppukottai MainRoad, villapuram</p>
                                    <p class="card-text">Contact: 9500028111</p>
                                </div>
                            </div>
                        </div>
                    </div>




                </div>
                <div class="modal-footer"
                    style="display: flex; justify-content: center; width: 100%; border-top: none; padding: 0;">
                    <button type="button" class="btn btn-theme btn-sm" data-dismiss="modal" id="cancel-btn"
                        aria-label="cancel Data" (click)="modal.dismiss('Cross click')">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<!-- 28-02-2025 -->

<ng-template #Termsmodel let-modal>
    <div class="modal-body">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="modal-body">
                    <div class="icon-box"
                        style="width: 40px; height: 40px; border-radius: 50%; background-color: #f5f5f5; display: flex; justify-content: center; align-items: center;">
                        <span style="color: red; font-size: 20px;">
                            <i class="fa fa-file-text-o" aria-hidden="true"></i>
                        </span>
                    </div>



                    <div class="text-center">
                        <h4 class="modal-title w-100 text-center mt-3">
                            Terms and Conditions</h4>
                        <i (click)="toggleSpeech()" class="mt-2"
                            [class]="isSpeaking ? 'fa fa-volume-off' : 'fa fa-volume-up' "
                            style="font-size: 30px; cursor: pointer; transition: transform 0.3s ease;"
                            aria-hidden="true"></i>
                    </div>




                    <div style="text-align: center; margin-top: 10px;">
                        <ul
                            style="list-style-type: none; padding-left: 0; text-align: left; margin: 0 auto; display: inline-block;margin-left: 50px;">
                            <li>1) Orders can be canceled up to 1 hour before the scheduled delivery time.</li>
                            <li>2) For customization or enquiry, contact customer support phone number:9003432888</li>
                            <li>3) To change the order quantity, place a new order or delete the old one and update the
                                quantity in the new order.</li>
                            <br>
                            <li class="mt-3"><a href="https://www.fbcakes.com/pages/Terms?name=Terms" target="_blank"
                                    style="color: #007bff; text-decoration: none;">
                                    <span>Terms for Service</span>
                                </a></li>
                        </ul>

                    </div>

                </div>
                <div class="modal-footer" style="flex-wrap: nowrap;justify-content: normal;display: block;">
                    <button type="button" class="btn btn-theme btn-sm" data-dismiss="modal" id="cancel-btn"
                        aria-label="cancel Data" (click)="closepopup() ">Cancel</button>

                    <button *ngIf="payment == 2" type="submit" class="btn btn-theme btn-sm" style="float: inline-end;"
                        id="placeord-btn" aria-label="placeord Data" (click)="placeOrderNow()">
                        Proceed
                    </button>

                    <button *ngIf="payment == 1" type="submit" class="btn btn-theme btn-sm " style="float: inline-end;"
                        id="placeorder-btn" aria-label="placeorder Data" (click)="placeOrderNowbyOnline()">
                        Proceed
                    </button>

                </div>
            </div>
        </div>
    </div>
</ng-template>